/* eslint-disable camelcase */
import * as React from "react"
import { StyleProp, TextStyle, View, ViewStyle, TouchableOpacity } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { JalaIcon } from "../jala-icon/jala-icon"
import { Text } from "../text/text"
import moment from "moment"
import { translate } from "../../i18n"

const MAIN_CONTAINER = (isRead):ViewStyle => ({
  flexDirection: 'row',
  backgroundColor: isRead ? color.palette.white : color.palette.ocean200,
  borderBottomWidth: 1,
  borderColor: color.palette.lineLight,
  paddingVertical: 12,
  paddingHorizontal: 14
})

const ICON_CONTAINER: ViewStyle = {
  width: 36,
  marginRight: 12
}

const ICON = (backgroundColor):ViewStyle => ({
  borderRadius: 18,
  backgroundColor,
  width: 36,
  height: 36,
  alignItems: 'center',
  justifyContent: 'center'
})

const CONTENT_CONTAINER: ViewStyle = {
  flex: 1
}

const SMALL_TEXT = (isRight):TextStyle => ({
  color: isRight ? color.palette.gray700 : color.palette.gray600,
  alignSelf: isRight ? 'flex-end' : 'flex-start'
})

const MIDDLE_TEXT: TextStyle = {
  color: color.palette.gray900,
  marginBottom: 8
}

export interface NotificationItemProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
  onPressItem?: () => void
  notification?: any
}

const getConstantsUsed = (notification) => {
  const { type } = notification;
  const notifType = type && type.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '');
  const result = notifType && notificationType.find((item) => item.type === notifType);
  return result;
}

const renderIcon = (notification) => {
  const constant = getConstantsUsed(notification);
  const iconName = constant.icon || '';
  const background = constant.background || '';
  const color = constant.color || '';
  return (
    <View style={ICON_CONTAINER}>
      <View style={ICON(background)}>
        <JalaIcon name={iconName} color={color} size={28} />
      </View>
    </View>
  );
}

const renderContent = (notification) => {
  const { body, title, data: { region_id, region }, created_at } = notification;
  const content = region ? region.full_name : (region_id || '').substring(0, 7);
  const contentUsed = title && ['Info Harga', 'Price Info'].includes(title) ? content : body || '-';
  const formDate = created_at ? moment.utc(created_at).local().format('DD MMM YYYY, HH:mm') : '-';
  const titleUsed = title && ['Info Harga', 'Price Info'].includes(title) ? translate('notifications.priceNotificationTitle') : title;
  return (
    <View style={CONTENT_CONTAINER}>
      <Text preset="caption2" style={SMALL_TEXT(false)} text={titleUsed} />
      <Text preset="title4" style={MIDDLE_TEXT} text={contentUsed} />
      <Text preset="caption2" style={SMALL_TEXT(true)} text={formDate} />
    </View>
  );
}

const notificationType = [
  { type: 'AppNotificationsReminderDailyCurrentCycleFeed', icon: 'feeds', color: color.palette.blueAzure, background: color.palette.ocean200 },
  { type: 'AppNotificationsReminderDailyMeasurement', icon: 'pond-1', color: color.palette.blueAzure, background: color.palette.ocean200 },
  { type: 'AppNotificationsReminderDailyCurrentCycleSampling', icon: 'sr-prediction', color: color.palette.blueAzure, background: color.palette.ocean200 },
  { type: 'AppNotificationsReminderDailyCurrentCycleHarvest', icon: 'harvest', color: color.palette.green500, background: color.palette.green300 },
  { type: 'AppNotificationsInfoFeedAccumulationFarmWeekly', icon: 'subtraction-212', color: color.palette.orange500, background: color.palette.orange300 },
  { type: 'AppNotificationsInfoBiomassPredictionFarmWeekly', icon: 'biomass', color: color.palette.orange500, background: color.palette.orange300 },
  { type: 'AppNotificationsCongratulationAgeCheckpoint', icon: 'age', color: color.palette.orange500, background: color.palette.orange300 },
  { type: 'AppNotificationsReportMonthlyFarm', icon: 'subtraction-212', color: color.palette.orange500, background: color.palette.orange300 },
  { type: 'AppNotificationsNewShrimpPriceInfo', icon: 'price', color: color.palette.orange500, background: color.palette.orange300 }
];

/**
 * Describe your component here
 */
export const NotificationItem = observer(function NotificationItem(props: NotificationItemProps) {
  const { onPressItem, notification } = props
  const isRead = !!notification.read_at;

  return (
    <TouchableOpacity style={MAIN_CONTAINER(isRead)} onPress={onPressItem}>
      {renderIcon(notification)}
      {renderContent(notification)}
    </TouchableOpacity>
  )
})
